module.exports = __webpack_public_path__ + "img/account-icon.31f039f3.svg";